import OverviewCard from '@/components/OverviewCard';
import { BlockMeta } from '@/lib/parsers/blocks';
import { parseColorScheme, parseLinkField } from '@/lib/parsers/common';
import { cleanHtml } from '@/lib/utils/htmlHelpers';
import { withFragment } from '@liquorice/gql-utils';
import { toStringOrNull } from '@liquorice/utils';
import { BlockContainer } from '../../BlockContainer';
import { EXTERNAL_CARD_BLOCK_FRAGMENT } from './useExternalCard';

export const ExternalCardBlockOverview = withFragment(
  EXTERNAL_CARD_BLOCK_FRAGMENT,
  (data, { parentMeta }: { parentMeta: BlockMeta }) => {
    if (!data) return null;

    const { heading, content, linkField, imageSingle, colorScheme } = data;
    const link = parseLinkField(linkField);
    const href = link?.href;
    const newWindow = link?.target === '_blank';
    const customText = link?.children;
    const title = toStringOrNull(heading);
    const description = cleanHtml(content);
    const colorSet = parseColorScheme(colorScheme);

    return (
      <BlockContainer
        disableContainer
        paddingY
        ContainerProps={{ disablePadding: true }}
        overflow
        colorSet={colorSet}
        paper
        meta={parentMeta}>
        <OverviewCard
          {...{
            item: {
              title,
              description,
              image: imageSingle,
              href,
              customText,
            },
            colorScheme,
            newWindow,
          }}
        />
      </BlockContainer>
    );
  }
);

export default ExternalCardBlockOverview;
